import React from 'react'

import './Home.css'

const Product2 = () => {
    return (
        <div className='rows-div'>
           


            <div id='row-2-below' className='row2'>

                <div id='row2-2-below'className='box1'><h2 id='row2-2-below-heading' className='box1-heading'>Shop our Kitchen store</h2> <img id='row2-2-below-img' className='box-img' src='https://m.media-amazon.com/images/I/419oiqASBkL._AC_SY400_.jpg' />
                    <p id='row2-2-below-para'  className='box-1-subpara'>See More</p>
                </div>


                <div  id='row2-2-below' className='box1'><h2 id='row2-2-below-heading' className='box1-heading'>repurchased in Home</h2> <img id='row2-2-below-img'className='box-img' src='https://m.media-amazon.com/images/I/71tiZCnU9KL._AC_SY400_.jpg' />
                    <p id='row2-2-below-para' className='box-1-subpara'>See More</p>
                </div>


                <div  id='row2-2-below' className='box1'><h2 id='row2-2-below-heading' className='box1-heading'>Today's deals</h2> <img className='box-img' src='https://m.media-amazon.com/images/I/613DHPSpZRL._AC_SY400_.jpg' />
                    <p id='row2-2-below-para' className='box-1-subpara'>See More</p>
                </div>

                <div  id='row2-2-below' className='box1'><h2 id='row2-2-below-heading' className='box1-heading'>New releases</h2> <img className='box-img' src='https://m.media-amazon.com/images/I/81lBJ004NdL._AC_SY400_.jpg' />
                    <p id='row2-2-below-para' className='box-1-subpara'>See More</p>
                </div>


            </div>

            <div className='row3'>
                <h1 id='todays-deal-txt' >Hot deal's</h1>
                <div className='flex-s-box'>
                    <div className='s-box1'> <img className='s-box-img' src='https://m.media-amazon.com/images/I/61fPH47Hd0L._AC_SY400_.jpg' />
                        <div className='s-box-1-full-subpara' ><p className='s-box-1-subpara'>38% off</p> <p className='s-box-1-subpara-2'>With Prime</p></div>
                        <div style={{ display: "flex", flexDirection: "row" }}><h4>$99.98</h4> <h5 style={{ marginLeft: "0.3rem", marginTop: "0.1rem", color: "rgb(92, 92, 92)" }} >List Price:$̶1̶5̶9̶.̶9̶8̶</h5></div>
                        <div style={{ fontSize: "13px" }} >Invite-Only Deal -JBL Flip</div>
                    </div>

                    <div className='s-box1'> <img className='s-box-img' src='https://m.media-amazon.com/images/I/41Fox2zcFVL._AC_SY400_.jpg' />
                        <div className='s-box-1-full-subpara' ><p className='s-box-1-subpara'>38% off</p> <p className='s-box-1-subpara-2'>With Prime</p></div>
                        <div style={{ display: "flex", flexDirection: "row" }}><h4>$99.98</h4> <h5 style={{ marginLeft: "0.3rem", marginTop: "0.1rem", color: "rgb(92, 92, 92)" }} >List Price:$̶1̶5̶9̶.̶9̶8̶</h5></div>
                        <div style={{ fontSize: "13px" }} >Invite-Only Deal -JBL Flip</div>
                    </div>


                    <div className='s-box1'> <img className='s-box-img' src='https://m.media-amazon.com/images/I/31E2wL1IGOL._AC_SY400_.jpg' />
                        <div className='s-box-1-full-subpara' ><p className='s-box-1-subpara'>38% off</p> <p className='s-box-1-subpara-2'>With Prime</p></div>
                        <div style={{ display: "flex", flexDirection: "row" }}><h4>$99.98</h4> <h5 style={{ marginLeft: "0.3rem", marginTop: "0.1rem", color: "rgb(92, 92, 92)" }} >List Price:$̶1̶5̶9̶.̶9̶8̶</h5></div>
                        <div style={{ fontSize: "13px" }} >Invite-Only Deal -JBL Flip</div>
                    </div>

                    <div className='s-box1'> <img className='s-box-img' src='https://m.media-amazon.com/images/I/81qKJbHIKuL._AC_UL640_QL65_.jpg' />
                        <div className='s-box-1-full-subpara' ><p className='s-box-1-subpara'>38% off</p> <p className='s-box-1-subpara-2'>With Prime</p></div>
                        <div style={{ display: "flex", flexDirection: "row" }}><h4>$99.98</h4> <h5 style={{ marginLeft: "0.3rem", marginTop: "0.1rem", color: "rgb(92, 92, 92)" }} >List Price:$̶1̶5̶9̶.̶9̶8̶</h5></div>
                        <div style={{ fontSize: "13px" }} >Invite-Only Deal -JBL Flip</div>
                    </div>

                    <div className='s-box1'> <img className='s-box-img' src='https://m.media-amazon.com/images/I/51NKjePjm5S._AC_UL640_QL65_.jpg' />
                        <div className='s-box-1-full-subpara' ><p className='s-box-1-subpara'>38% off</p> <p className='s-box-1-subpara-2'>With Prime</p></div>
                        <div style={{ display: "flex", flexDirection: "row" }}><h4>$99.98</h4> <h5 style={{ marginLeft: "0.3rem", marginTop: "0.1rem", color: "rgb(92, 92, 92)" }} >List Price:$̶1̶5̶9̶.̶9̶8̶</h5></div>
                        <div style={{ fontSize: "13px" }} >Invite-Only Deal -JBL Flip</div>
                    </div>

                </div>


            </div>
        </div>

    )
}

export default Product2
